export default __webpack_public_path__ + "static/media/amount-logo.6dfd29c6.svg";